import React, { useState, useEffect } from "react"
import Select from "react-select"
import Modal from "react-modal"

import { SingleOption, customStyles, parseBudat, getLocaleStringRoundedInt } from "../../utils/utils.js"
import { showGreyBackground, hideGreyBackground, scrollTo } from "../../utils/windows.js"
import { customModalStyles } from "../../utils/styles"
import { allMateriales } from "../../utils/materiales"

import closeIcon from "../../../assets/img/cross-icon.svg"
import chevronRight from "../../../assets/img/chevron-right.svg"

const styles = customModalStyles(20)
styles.content.padding = 0

export const AsignacionEntradasMobile = ({ 
  pedidos,
  materiales,
  editPedido,
  handleCheckedPedidos,
  confirmCheckedPedidos,
  displayPedidoModal,
  changePedidoModal
}) => {
  const [editingPedido, setEditingPedido] = useState()
  const [editingPedidoId, setEditingPedidoId] = useState()
  const [selectingPedidos, setSelectingPedidos] = useState(false)

  useEffect(() => {
    if(editingPedidoId)
      setEditingPedido(pedidos.find(p => p.ID_PEDIDO === editingPedidoId))
  }, [pedidos])

  const closeModal = () => {
    setEditingPedido()
    setSelectingPedidos(false)
    hideGreyBackground()
  }

  const showPedido = (pedido, idPedido) => {
    showGreyBackground()
    scrollTo(0, 0)
    setEditingPedido(pedido)
    setEditingPedidoId(idPedido)
  }

  const openPedidosModal = () => {
    console.log("Abriendo modal pedidos")
    showGreyBackground()
    scrollTo(0, 0)
    setSelectingPedidos(true)
  }

  const preConfirmCheckedPedidos = () => {
    setSelectingPedidos(false)
    hideGreyBackground()
    confirmCheckedPedidos()
  }
  
  return (
    <div className={`hide-desktop ${selectingPedidos?"min-height-2000": ""} ${displayPedidoModal?"min-height-1200": ""}`}>
      <div className="big-subtitle">
        ASIGNACIÓN ENTRADAS
        <button
          className="main-button mobile-button show-only-tablet seleccionar-pedidos-tablet-button"
          onClick={openPedidosModal}
        >
          Seleccionar Pedidos
        </button>
        <hr className="title-separator-line" />
      </div>
      <table className="responsive-table separated-th-table">
        <thead>
          <tr>
            <th>
              <div className="th-data two">Identificador<br />Entrada</div>
            </th>
            <th>
              <div className="th-data">Fecha</div>
            </th>
            <th>
              <div className="th-data">Hora</div>
            </th>
          </tr>
        </thead>
        <tbody>
          { pedidos && pedidos.filter((pedido) => pedido.checked && !pedido.used).map((pedido, pedidoKey) =>
            <tr key={pedido.ID_PEDIDO}>
              <td>
                <div className="underline" onClick={(e)=>changePedidoModal(e, pedido)}>{pedido.ID_PEDIDO}</div>
              </td>
              <td>
                {`${pedido.FECHA.split("-")[2]}/${pedido.FECHA.split("-")[1]}/${pedido.FECHA.split("-")[0]}`}
              </td>
              <td>
                {pedido.HORA.substring(0,5)}
                <a className="show-mobile-details">
                  <img src={chevronRight} onClick={() => showPedido(pedido, pedido.ID_PEDIDO)} />
                </a>
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <div className="responsive-actions show-only-mobile">
        <button
          className="main-button"
          onClick={openPedidosModal}
        >
          Seleccionar Pedidos
        </button>
        <hr className="mobile-sections-separator" />
      </div>
    
      {editingPedido &&
        <Modal isOpen={true} onRequestClose={closeModal} style={styles} className="responsive-modal">
          <div className="mobile-filters__title responsive-filters">
            <h1 className="responsive-modal-title">Asignación de Entradas</h1>
            <button className="mobile-filters__close-btn" onClick={closeModal}>
              <img src={closeIcon} alt="close modal" />
            </button>
          </div>
          <div className="mobile-filters__main-section">
            { editingPedido.DESCARGAS.map((descarga, descargaKey) =>
                <div className="asignacion-entradas-descarga" key={`${descarga.material}-${descarga.compartimiento}`}>
                  COMP. {descarga.compartimiento} / {allMateriales[descarga.material].titleCierre} / VOLUMEN (LTS): {getLocaleStringRoundedInt(descarga.volumen)}
                  <Select
                    className="eds-select"
                    value={descarga.tanque}
                    onChange={(e) => editPedido(e, editingPedido.ID_PEDIDO, descarga)}
                    closeMenuOnSelect={true}
                    hideSelectedOptions={false}
                    options={descarga.tanquesOptions}
                    components={{ SingleOption, IndicatorSeparator: () => null }}
                    isClearable={false}
                    autosize={false}
                    placeholder="Seleccionar Tanque"
                    isSearchable={false}
                    styles={customStyles}
                  />
                </div>
              )}

          </div>
          <div className="mobile-filters__footer">
            <button className="main-button" onClick={closeModal}>
              Cerrar
            </button>
          </div>
        </Modal>
      }

      {selectingPedidos &&
        <Modal isOpen={true} onRequestClose={closeModal} style={styles} className="responsive-modal">
          <div className="mobile-filters__title responsive-filters">
            <h1 className="responsive-modal-title">Seleccionar Pedido</h1>
            <button className="mobile-filters__close-btn" onClick={closeModal}>
              <img src={closeIcon} alt="close modal" />
            </button>
          </div>
          <div className="mobile-filters__main-section">
            <table className="responsive-table separated-th-table">
              <thead>
                <tr>
                  <th>
                    <div className="th-data">Detalle</div>
                  </th>
                  <th>
                    <div className="th-data">Acción</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {pedidos?.length === 0 &&
                  <tr>
                    <td colSpan="100%" className="cell-border-top-left cell-border-top-right">
                      Ud. no cuenta con entradas en el día seleccionado
                    </td>
                  </tr>
                }

                {pedidos?.map((pedido, key) => (
                  <tr className="row-with-border" key={`pedido-${pedido.ID_PEDIDO}`}>
                    <td className="seleccionar-pedidos-table">
                      <b>Identificador: </b>{pedido.ID_PEDIDO}<br />
                      <b>Fecha de Entrada: </b>{pedido.FECHA}<br />
                      <b>Hora: </b>{pedido.HORA}<br />
                      <b>Volumen Total: </b>{pedido.VOLUMEN_TOTAL}
                    </td>
                    <td>
                      <input type="checkbox" defaultChecked={pedido.checked}
                        onClick={() => handleCheckedPedidos(pedido.ID_PEDIDO)} disabled={pedido.blocked || pedido.CONTINGENCIA !== "X"} />
                    </td>
                  </tr>
                ))}

              </tbody>
            </table>

          </div>
          <div className="mobile-filters__footer">
            <button className="main-button mobile-button" onClick={preConfirmCheckedPedidos}>
              Confirmar
            </button>
            <button className="main-button hallow mobile-button" onClick={closeModal}>
              Cancelar
            </button>
          </div>
        </Modal>
      }


    </div>
  )
}
